import { render, staticRenderFns } from "./beading.vue?vue&type=template&id=35648f27&scoped=true&"
import script from "./beading.vue?vue&type=script&lang=js&"
export * from "./beading.vue?vue&type=script&lang=js&"
import style0 from "./beading.vue?vue&type=style&index=0&id=35648f27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35648f27",
  null
  
)

export default component.exports